import { render, staticRenderFns } from "./invest_qrcode.vue?vue&type=template&id=a12186cc&scoped=true"
import script from "./invest_qrcode.vue?vue&type=script&lang=js"
export * from "./invest_qrcode.vue?vue&type=script&lang=js"
import style0 from "./invest_qrcode.vue?vue&type=style&index=0&id=a12186cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12186cc",
  null
  
)

export default component.exports